export default __webpack_public_path__ + "static/media/education-graduate-outline-16px.97f0b9be.svg";